import * as UserMutations from './user.mutations';
import * as UserQueries from './user.queries';

export { UserQueries, UserMutations };
